<template>
  <kst-modal-search multiple
    :module="Model.Module"
    :moduleType="Model.ModuleType.SearchList"
    :searchData="searchData"
    :sub-title="modal_subTitle"
    :width="1000"
    @init="handleModal_Init"
    @load="handleModal_Load"
    @loaded="handleModal_Loaded"
    @reset="handleModal_Reset"
    @submit="handleModal_Submit"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data, userData }">
      <List
        :items="data.StockList"
        :userData="userData"
        :maxSelectable="MaxSelectable"
        :sellPrice="sellPrice"
        :weight="weight"
        @check="handleList_Check"
      />
    </template>
  </kst-modal-search>
</template>

<script>
import SnackbarMixin from "../../../mixins/SnackbarMixin.js";
import Model from "../StkModel.js";

import List from "./StkScLDefaultMultiple_List.vue";
import Search from "../SearchListDefault/StkScLDefault_Search.vue";

/**
 * flow (how to use):
 * 1. handle Init event, set and do show when needed
 * 2. handle Loaded when needed
 * 3. handle Submit event
 *
 * note: multi-select (checkbox) — baris stok terpilih terkirim sebagai Array,
 * urutan itemDetailsList sejajar (berpasangan by index) dengan stockList.
 */
export default {
  mixins: [SnackbarMixin],
  components: {
    List,
    Search
  },
  props: {
    // field visibility (order by appearance)
    sellPrice: Boolean,
    weight: Boolean
  },
  data: () => ({
    Model: Model,
    MaxSelectable: 50,
    searchData: {
      Search: "",
      WarehouseID: null
    },
    stockList: [],
    getDetailsService: null,
    getListService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  computed: {
    modal_subTitle() {
      return this.stockList.length + " " +
        this.Model.Item.Module.FullName.toLowerCase() + " terpilih " +
        "(maksimal " + this.MaxSelectable + ")";
    }
  },
  methods: {
    /*** public method ***/

    show(warehouseId, getListService, getDetailsService) {
      this.searchData.WarehouseID = warehouseId;
      this.getListService = getListService;
      this.getDetailsService = getDetailsService;
      this.showFunc();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    /*** by modal ***/

    handleModal_Init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;
      this.init_Data();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_Load(loadList) {
      const options = this.getListOptions();
      const config = this.getListService(options);
      loadList(config);
    },

    handleModal_Loaded(data) {
      this.$emit(this.$kst.Enum.Event.Loaded, data.StockList);
    },

    handleModal_Reset(loadList) {
      this.init_Data();
      this.handleModal_Load(loadList);
    },

    handleModal_Submit(checkedRows, loadRelatedList) {
      if (checkedRows.length < 1) {
        return;
      }

      if (this.getDetailsService) {
        this.stockList = checkedRows;

        const options = this.getRelatedListOptions(checkedRows);
        const config = this.getDetailsService(options);
        loadRelatedList(config, this.handleModal_Submit_Success);
      }
      else {
        this.$emit(this.$kst.Enum.Event.Submit, checkedRows);
        this.hideFunc();
      }
    },
    handleModal_Submit_Success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, this.stockList,
        data.ItemDetailsList);
      this.hideFunc();
    },

    /*** by list ***/

    handleList_Check(checkedRows) {
      this.stockList = checkedRows;
    },

    /*** custom ***/

    getListOptions() {
      return {
        warehouse: this.searchData.WarehouseID,
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.SearchListFields
      };
    },

    getRelatedListOptions(checkedRows) {
      let idList = [];
      for (const row of checkedRows) {
        idList.push(row.ItemID);
      }

      return {
        item: idList,
        warehouse: this.searchData.WarehouseID
      };
    },

    init_Data() {
      this.stockList = [];
      // searchData
      this.searchData.Search = "";
    }
  }
}
</script>